// Libraries
import React from 'react';

// Supermove
import {DataLoader} from '@supermove/components';
import {gql} from '@supermove/graphql';
import {useQuery, useUrlFilters} from '@supermove/hooks';

// App
import SettingsProjectStages from '@shared/modules/Settings/components/SettingsProjectStages';
import ProjectSettingsPage from 'modules/Organization/Settings/Project/ProjectSettingsPage';

const ProjectSettingsPageStages = () => {
  const {loading, data, refetch} = useQuery(ProjectSettingsPageStages.query, {
    fetchPolicy: 'cache-and-network',
  });

  const urlFilters = useUrlFilters({
    getRoute: () => 'SettingsStagesPage',
    filterKeys: ['isArchived'],
  });

  return (
    <ProjectSettingsPage
      title='Project Stages'
      description='Configure your lead stages to align with your workflow. Drag and drop to adjust the order, and preview how they will be displayed in the leads tab.'
      isCompanySettings
    >
      <DataLoader loading={loading || !data} data={data}>
        {({loadedData}) => {
          const {salesStages, archivedSalesStages} =
            loadedData.viewer.viewingOrganization.companySettings;

          return (
            <SettingsProjectStages
              stages={urlFilters.get('isArchived') ? archivedSalesStages : salesStages}
              handleAdd={() => {
                // TODO: Implement handleAdd logic
              }}
              handleView={() => {
                // TODO: Implement handleEdit logic
              }}
              refetch={refetch}
              scrollViewStyle={{paddingLeft: 24}}
            />
          );
        }}
      </DataLoader>
    </ProjectSettingsPage>
  );
};

// --------------------------------------------------
// Data
// --------------------------------------------------
ProjectSettingsPageStages.query = gql`
  ${SettingsProjectStages.fragment}

  query ProjectSettingsPageStages {
    ${gql.query}
    viewer {
      id
      viewingOrganization {
        id
        companySettings {
          salesStages {
            id
            ...SettingsProjectStages
          }
          archivedSalesStages {
            id
            ...SettingsProjectStages
          }
        }
      }
    }
  }
`;

export default ProjectSettingsPageStages;
